import "../styles/esign.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import { Button, Card, Container, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "./Langs";
import Navbar from "./Navbar";
import swal from "sweetalert";
import GetLogo from "./GetLogo";
import axios from "axios";
import { getUrl, getApiUrl } from "./urlHook";
const apiUrl = getApiUrl();

const Validate = async (props) => {
  const email = props.email;
  const navigate = props.navigate;
  const sessionResult = props.sessionResult;

  await swal({
    title: "Password sent to email",
    text: "An email with your one time password was sent to your email.",
    icon: "info",
    content: {
      element: "input",
    },
    closeOnEsc: false,
    closeOnClickOutside: false,
    buttons: {
      cancel: true,
      confirm: "Login",
    },
  }).then(async (r) => {
    await axios
      .post(
        `${apiUrl}/validate`,
        {
          email: email.trim(),
          password: r.toString().trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((r) => {
        navigate(`/browse`, {
          state: {
            session: sessionResult.data,
          },
        });
      })
      .catch(async (e) => {
        await swal({
          title: "Failed to login",
          text: "Please try again",
          icon: "warning",
          closeOnEsc: false,
        }).then(async (res) => {
          // have the password prompt come up again
          await Validate(props);
        });
      });
  });
};

const Login = (props) => {
  const [openHelp, setOpenHelp] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const navigate = useNavigate();
  const logo = GetLogo();
  const [lang, setLang] = useLanguage();

  const submitCheck = async () => {
    const email = emailInput.toString();

    if (email === "" || email.length === 0) {
      await swal({
        title: "You must enter an email to continue",
        icon: "warning",
        closeOnClickOutside: false,
      });
      return false;
    }

    if (email === " " || !email.includes("@") || !email.includes(".")) {
      await swal({
        title: "Must enter valid email address",
        icon: "warning",
        closeOnClickOutside: false,
      });
      return false;
    }

    const res = await axios
      .post(
        `${apiUrl}/createSession`,
        {
          email: email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch(async (e) => {
        await swal({
          title: "Invalid Input",
          text: `${e}`,
          icon: "error",
          closeOnClickOutside: false,
        });
      });

    if (res.status === 200) {
      Validate({
        email: email,
        sessionResult: res,
        navigate: navigate,
      });
    }

    return true;
  };

  useEffect(() => {
    try {
      swal.close();
    } catch (e) {
      console.log("no swals active");
    }
  }, []);

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        setOpenHelp={setOpenHelp}
        openHelp={openHelp}
        color={logo.color}
        banner={logo.banner}
        helpColor={logo.helpColor}
      ></Navbar>

      <Container className="access-container mt-5">
        <Card
          className="mini-card norm-card"
          style={{
            width: "100%",
            maxWidth: "650px",
            textAlign: "center",
            margin: "0 auto",
            marginTop: "100px",
            height: "auto",
            paddingTop: "25px",
            paddingBottom: "25px",
            boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
            borderColor: "transparent",
          }}
        >
          <Card.Body style={{ margin: "0 auto" }}>
            <Form
              role="form"
              data-toggle="validator"
              lang={lang.Current}
              onSubmit={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              <Form.Group>
                <Form.Label
                  style={{
                    textAlign: "center",
                    fontSize: "48px",
                    wordWrap: "break-word",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontWeight: "bold",
                  }}
                >
                  {lang.Login}
                  <hr></hr>
                </Form.Label>
                <h6 style={{ marginBottom: "25px", color: "gray" }}>
                  {lang.LoginEmail}
                </h6>
                <Form.Group>
                  <input
                    style={{
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                    onChange={(e) => {
                      setEmailInput(e.target.value);
                    }}
                    onKeyUp={async (e) => {
                      if (e.keyCode === 13) {
                        await submitCheck();
                        e.preventDefault();
                        return false;
                      }
                      return false;
                    }}
                    name="email"
                    type="email"
                    className="form-control"
                    id="emailInput"
                    minLength={1}
                    maxLength={100}
                    placeholder={lang.EnterEmail}
                    required
                  />
                  <div className="help-block with-errors"></div>
                  <Button
                    id="buttonSubmit"
                    type="button"
                    variant="primary"
                    style={{
                      margin: "0 auto",
                      marginTop: "40px",
                      marginBottom: "0px",
                      width: "100%",
                      maxWidth: "200px",
                      display: "block",
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      return false;
                    }}
                    onKeyPress={async (e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        e.stopPropagation();
                        await submitCheck();
                        return false;
                      }
                      return false;
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      await submitCheck();
                      return true;
                    }}
                  >
                    {lang.ViewDocuments}
                  </Button>
                </Form.Group>
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <p
        style={{
          textAlign: "center",
          margin: "50px",
          marginTop: "40px",
          paddingTop: "20px",
        }}
      >
        {lang.Experience}: <br></br>
        <a href="mailto:info@myshs.com">info@myshs.com</a>
      </p>
    </div>
  );
};
export default Login;
